import { and, asc, eq } from "drizzle-orm";
import { type PowerSyncDrizzleDB, reservation } from "@comandero/powersync";
import { liveReservationFilters } from "../live/filters";

/** Reservations + waitlist for branch, ordered by reservation time. */
export function getReservationsQuery(db: PowerSyncDrizzleDB, branchId: string) {
  return db
    .select()
    .from(reservation)
    .where(and(eq(reservation.branch_id, branchId), ...liveReservationFilters()))
    .orderBy(asc(reservation.reserved_at), asc(reservation.created_at));
}
